import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import ErrorText from './../ErrorText';
import useInputTimeRange from './useInputTimeRange';

const InputTimeRange = ({ value, onChange, name, minTime, label, error, t }) => {
  const { startTime, endTime, isError, isErrorMin, handleChangeStart, handleChangeEnd } = useInputTimeRange({ value, onChange, name, minTime });

  return (
    <Fragment>
      {label && <label className="input-time-range__label"> {label}</label>}
      <div className={`input-time-range ${error ? 'input-time-range--error' : ''}`}>
        <input type="time" className={`input-time-range__input`} value={startTime} onChange={handleChangeStart} required />
        <div className="input-time-range__separator-container">
          <div className="input-time-range__separator"></div>
        </div>
        <input type="time" className={`input-time-range__input`} value={endTime} onChange={handleChangeEnd} required />
      </div>
      {isError && <ErrorText>{t('front_agenda:Horario incorrecto')}.</ErrorText>}
      {isErrorMin && <ErrorText> {t('front_agenda:La hora de inicio debe de ser mayor que la hora actual')}.</ErrorText>}
    </Fragment>
  );
};

InputTimeRange.propTypes = {
  minTime: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.array,
};

InputTimeRange.defaultProps = {
  minTime: undefined,
  name: 'timerange',
  value: [new Date(), new Date()],
  onChange: function () {},
};

export default withTranslation(['new-course', 'placeholder'])(InputTimeRange);
